<section class="grammarCheckerWithoutInternet">
    <div class="trinka_container container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="trinka-title mobile-top-40">
                    <h2 class="text-white mb-4">Data Privacy Evaluation Checklist</h2>
                    <p class="text-white w-100">Download this checklist, designed to support internal security and compliance evaluations.</p>
                </div>
                <div class="btn-group mt-40">
                    <a 
                        class="white-btn"
                            [class.disabled]="downloadingMap['/assets/resources/Trinka-Confidential-Data-Plan-Checklist.pdf']"
                            [style.pointerEvents]="downloadingMap['/assets/resources/Trinka-Confidential-Data-Plan-Checklist.pdf'] ? 'none' : 'auto'"
                            (click)="openResourcePDF(
                                '/assets/resources/Trinka-Confidential-Data-Plan-Checklist.pdf',
                                'Data Privacy Evaluation Checklist'
                            )"
                        >
                        <span *ngIf="downloadingMap['/assets/resources/Trinka-Confidential-Data-Plan-Checklist.pdf']"
                                class="spinner-border spinner-border-sm me-2"></span>
                        <img src="assets/images/enterprise/confidential-data/pdf-icon.png" alt="download icon" class="mr-2" />        
                        {{ downloadingMap['/assets/resources/Trinka-Confidential-Data-Plan-Checklist.pdf'] ? 'Downloading...' : 'Download Infosheet' }}
                    </a>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="text-center">
                    <img src="assets/images/enterprise/confidential-data/whitepaper.webp" class="img-fluid" alt="whitepaper" />
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal" id="CaptureLeadForm">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal"></button>
                <app-capture-lead 
                [resourceUrl]="selectedLink"
                [resourceTitle]="selectedTitle"
                (formSubmitted)="onFormSubmitted($event)">
                </app-capture-lead>
            </div>
        </div>
    </div>
</div>

